module.exports = __webpack_public_path__ + "static/media/001B_infopanel.5f3ee7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/001B_infopanel.png
// module id = 634
// module chunks = 0